<mat-drawer-container [formGroup]="filtersForm">
  <mat-drawer mode="over" #filterDrawer class="p-16" autoFocus="false">
    <div class="fx-column">
      <span class="text bold">{{ 'INTEGRATIONS.FILTERS' | translate }}</span>

      <app-select initial="none" label="{{ 'INTEGRATIONS.WEBSITE.RECURRENCE' | translate }}" [options]="recurrences"
        [multiple]="true" [emitOnInit]="false" formControlName="recurrence" [labelOutside]="true"
        class="mt-20 fx-flex"></app-select>

      <app-select initial="none" label="{{ 'INTEGRATIONS.TYPE' | translate }}" [options]="types"
        [multiple]="true" [emitOnInit]="false" formControlName="type" [labelOutside]="true"
        class="mt-10 fx-flex"></app-select>

      <app-trademark-select label="{{ 'INTEGRATIONS.WEBSITE.LINKED_TRADEMARKS' | translate }}" [multiple]="true" [search]="true"
        [emitOnInit]="false" formControlName="trademark" [labelOutside]="true" class="mt-10 fx-flex"></app-trademark-select>

      <app-territory-select label="{{ 'INTEGRATIONS.WEBSITE.LINKED_COUNTRIES' | translate }}" [multiple]="true" [search]="true"
        [emitOnInit]="false" formControlName="countries" [labelOutside]="true"
        class="mt-10 fx-flex"></app-territory-select>

      <button class="mt-20" [class.main-button]="activeFiltersCount() > 0" [class.button]="activeFiltersCount() === 0"
        (click)="filterDrawer.close()">
        {{ (activeFiltersCount() > 0 ? 'ACTIONS.SEE_RESULTS' : 'ACTIONS.CLOSE') | translate }}
      </button>
    </div>
  </mat-drawer>

  <mat-drawer-content class="p-16">
    <div class="fx-row align-items-center justify-content-between">
      <div class="fx-row fw-wrap align-items-center justify-content-start">
        <button class="button" (click)="filterDrawer.toggle()">
          <div class="fx-row align-items-center justify-content-start">
            <mat-icon class="mr-5" fontSet="material-icons-outlined">filter_list</mat-icon>
            {{ 'INTEGRATIONS.FILTERS' | translate }}
            @if (activeFiltersCount() > 0) {
              <div class="badge ml-5 white">{{ activeFiltersCount() }}</div>
            }
          </div>
        </button>

        <app-select initial="none" label="{{ 'INTEGRATIONS.STATUS' | translate }}" [options]="statuses"
          [multiple]="true" [emitOnInit]="false" formControlName="status" class="ml-10 status-select"
          style="width:210px;"></app-select>

        <div class="ml-10 fx-row fw-wrap align-items-baseline justify-content-start">
          <app-animated-number [value]="count()" [class]="'bold main'"></app-animated-number>
          &nbsp;
          <span class="text">
            <span class="bold main">{{ ((count() > 1 ? 'ENTITIES.INTEGRATIONS' : 'ENTITIES.INTEGRATION') | translate).toLowerCase() }}</span>
            {{ ('UTILS.MATCHING' | translate).toLowerCase() }}
          </span>
        </div>
      </div>

      <div class="fx-row align-items-center justify-content-start">
        <app-input placeholder="{{ 'ACTIONS.SEARCH' | translate }}..." type="text" prefix="search"
          formControlName="query" style="width:210px;"></app-input>
        <button class="main-button ml-10" (click)="refresh.emit()" [disabled]="loading()" [class.disabled]="loading()">
          <div class="fx-row align-items-center justify-content-start">
            <mat-icon [class.spinning]="autoRefresh()" matTooltip="{{ 'INTEGRATIONS.AUTO_REFRESHING' | translate }}"
              [matTooltipDisabled]="!autoRefresh()" class="mr-5"
              [matTooltipClass]="{'uzai-tooltip':true}">refresh</mat-icon>
            <span>{{ 'ACTIONS.REFRESH' | translate }}</span>
          </div>
        </button>
      </div>
    </div>

    <mat-divider class="mt-16"></mat-divider>

    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
